import { styled } from "simplydo/react/styled";

import type { CheckboxSlotProps } from "./Checkbox.types";
import { CheckboxChildren } from "./CheckboxChildren";
import { useCheckboxContext } from "./CheckboxContext";

const CheckboxWhenCheckedComponent = (props: CheckboxSlotProps) => {
  const { checked } = useCheckboxContext();

  if (!checked) {
    return null;
  }

  return <CheckboxChildren {...props} />;
};

export const CheckboxWhenChecked = styled(CheckboxWhenCheckedComponent)``;
CheckboxWhenChecked.displayName = "CheckboxWhenChecked";
